export enum actionTypes {
    SET_COOKIES_GROUPS = 'COOKIE_SETTINGS:COOKIES_GROUPS:SET',
    SET_COMMON_COOKIE_FLAG = 'COOKIE_SETTINGS:COMMON_COOKIE_FLAG:SET',
    SET_COOKIES_GROUPS_INITIAL = 'COOKIE_SETTINGS:COOKIES_GROUPS:INITIAL_SET'
}
